"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var uuid = require("uuid/v4");
var Donut = /** @class */ (function (_super) {
    __extends(Donut, _super);
    function Donut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = __assign({}, _this.props);
        _this.colors = ['orange', 'yellow', 'green', 'cyan', 'blue', 'purple'];
        _this.id = '';
        return _this;
    }
    Donut.prototype.componentWillMount = function () {
        this.id = uuid();
    };
    Donut.prototype.componentWillReceiveProps = function (newProps) {
        this.setState(newProps);
    };
    Donut.prototype.render = function () {
        var _this = this;
        var radius = 180;
        var activeRadius = 200;
        var total = this.state.items.reduce(function (acc, it) { return acc + it.value; }, 0);
        var sectors = this.state.items.map(function (it, i) {
            var r = it.active ? activeRadius : radius;
            var rotate = 0;
            var degree = (it.value / total) * 180;
            var color = it.color ? it.color : _this.colors[i % _this.colors.length];
            var x = Math.sin((degree * Math.PI) / 180) * r;
            var y = 0 - Math.cos((degree * Math.PI) / 180) * r;
            var active = it.active;
            return { x: x, y: y, degree: degree, rotate: rotate, color: color, active: active };
        });
        for (var i = 0; i < sectors.length; i = i + 1) {
            var sector = sectors[i];
            sector.rotate =
                i === 0 ? 0 : sectors[i - 1].rotate + sectors[i - 1].degree;
            sectors[i] = sector;
        }
        sectors = sectors.map(function (it) { return (__assign({}, it, { x: Math.floor(it.x), y: Math.floor(it.y), degree: Math.floor(it.degree), rotate: Math.floor(it.rotate) })); });
        var legends = this.state.items.map(function (it, i) { return (__assign({}, it, { color: it.color ? it.color : sectors[i].color })); });
        var inlineStyles = "\n      .svg-donut-caption {\n        font-size: 10pt;\n        fill: #666;\n        font-family: Open Sans, Helvetica, sans;\n      }\n      .svg-donut-center {\n        letter-spacing: -1px;\n        font-weight: bold;\n        font-size: 30pt;\n        fill: #333;\n        font-family: Open Sans, Helvetica;\n      }\n      .svg-donut-sector {\n        cursor:pointer;\n        transition: all 0.1s ease-out;\n      }\n      .svg-donut-legend-circle {\n        transition: all 0.1s ease-out;\n      }\n      .svg-donut-legend {\n        cursor:pointer;\n      }\n      .svg-donut-legend--active {\n        color: #000;\n        text-decoration: underline;\n      }\n    ";
        var renderPath = function (sector, i) {
            var onSectorHover = function () {
                _this.state.onHover(_this.state.items[i], i);
            };
            var r = sector.active ? activeRadius : radius;
            var d = "M 0 0 V -" + r + " A " + r + " " + r + " 0 0 1 " + sector.x + " " + sector.y + " Z";
            var rotate = "rotate(" + sector.rotate + ")";
            return (React.createElement("path", { className: "svg-donut-sector", onMouseOver: onSectorHover, key: i, fill: sector.color, d: d, transform: rotate },
                React.createElement("title", null, legends[i].valueText ? legends[i].valueText : legends[i].value)));
        };
        var renderLegend = function (legend, i) {
            var onLegendHover = function () {
                _this.state.onHover(_this.state.items[i], i);
            };
            var yOffset = (2 * i + 1) * 12;
            var xOffset = legend.active ? '1' : '5';
            var transform = "translate(0 -" + yOffset + ")";
            var fill = legend.color;
            var legendClass = "svg-donut-legend " + (legend.active ? 'svg-donut-legend--active' : '');
            return (React.createElement("g", { onMouseOver: onLegendHover, key: i, transform: transform },
                React.createElement("circle", { className: "svg-donut-legend-circle", r: "8", cx: xOffset, cy: "5", fill: fill }),
                React.createElement("text", { className: legendClass, x: "18", y: "10" },
                    React.createElement("title", null, legend.valueText ? legend.valueText : legend.value),
                    legend.name)));
        };
        var mask = "url(#" + this.id + ")";
        var maskId = this.id;
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", viewBox: "0 0 400 400" },
            React.createElement("style", null, inlineStyles),
            React.createElement("g", { transform: "translate(80 200)" },
                React.createElement("g", { mask: mask }, sectors.map(renderPath)),
                React.createElement("mask", { id: maskId },
                    React.createElement("rect", { x: "-200", y: "-200", fill: "white", width: "400", height: "400" }),
                    React.createElement("circle", { fill: "black", r: "120" }))),
            React.createElement("g", { transform: "translate(285 395)", className: "svg-donut-caption" }, legends.map(renderLegend)),
            React.createElement("g", { transform: "translate(90 200)" },
                React.createElement("text", { width: "120", x: "-80", y: "-4", className: "svg-donut-center" }, this.props.value),
                React.createElement("text", { width: "30", x: "60", y: "-4", className: "svg-donut-caption" }, this.props.unit),
                React.createElement("text", { width: "120", x: "-80", y: "14", className: "svg-donut-caption" }, this.props.caption))));
    };
    return Donut;
}(React.Component));
exports["default"] = Donut;
